import { render } from "./JoinPublicationExistingUser.vue.js?vue&type=template&id=a6ba1180&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=template&id=a6ba1180&scoped=true"
import script from "./JoinPublicationExistingUser.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=script&lang=js"
export * from "./JoinPublicationExistingUser.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=script&lang=js"

import "./JoinPublicationExistingUser.vue.scss?vue&type=style&index=0&id=a6ba1180&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=style&index=0&id=a6ba1180&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ba1180"],['__file',"src/Web/scripts/components/join-publication/JoinPublicationExistingUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6ba1180"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6ba1180', __exports__)) {
    api.reload('a6ba1180', __exports__)
  }
  
  module.hot.accept("./JoinPublicationExistingUser.vue.js?vue&type=template&id=a6ba1180&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationExistingUser.vue?vue&type=template&id=a6ba1180&scoped=true", () => {
    api.rerender('a6ba1180', render)
  })

}


export default __exports__